{
  "name": "bunvm",
  "version": "1.2.1",
  "description": "Bun Version Manager - Switch between different versions of Bun easily",
  "bin": {
    "bvm": "./dist/bvm.js"
  },
  "type": "module",
  "main": "./dist/bvm.js",
  "module": "./dist/bvm.js",
  "engines": {
    "node": ">=20"
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsx src/bvm.ts",
    "clean": "rm -rf dist",
    "prepublishOnly": "pnpm run clean && pnpm run build",
    "start": "node dist/bvm.js",
    "format": "prettier --write --cache .",
    "lint": "eslint --ext .ts src --cache",
    "lint:fix": "eslint --ext .ts src --cache --fix",
    "typecheck": "tsc --noEmit",
    "test": "bun test",
    "release": "pnpm lint && pnpm format && pnpm version patch && git push --follow-tags && pnpm publish",
    "release:minor": "pnpm version minor && git push --follow-tags && pnpm publish",
    "release:major": "pnpm version major && git push --follow-tags && pnpm publish"
  },
  "keywords": [
    "bun",
    "version",
    "manager",
    "version-manager",
    "bun version manager",
    "cli",
    "javascript",
    "typescript",
    "nodejs"
  ],
  "author": "Tarun Joshi",
  "license": "MIT",
  "homepage": "https://github.com/MrHacker26/bvm#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/MrHacker26/bvm.git"
  },
  "bugs": {
    "url": "https://github.com/MrHacker26/bvm/issues"
  },
  "files": [
    "dist"
  ],
  "publishConfig": {
    "access": "public"
  },
  "packageManager": "pnpm@10.11.0",
  "dependencies": {
    "@clack/prompts": "1.6.0",
    "chalk": "5.6.2",
    "cli-progress": "3.12.0",
    "commander": "13.1.0",
    "unzipper": "0.12.5",
    "update-notifier": "7.3.1"
  },
  "devDependencies": {
    "@eslint/js": "9.27.0",
    "@types/bun": "1.3.14",
    "@types/cli-progress": "3.11.6",
    "@types/node": "22.15.18",
    "@types/unzipper": "0.10.11",
    "@types/update-notifier": "6.0.8",
    "@typescript-eslint/eslint-plugin": "8.62.0",
    "@typescript-eslint/parser": "8.62.0",
    "eslint": "9.27.0",
    "globals": "16.1.0",
    "prettier": "3.8.5",
    "tsup": "8.5.1",
    "tsx": "4.22.4",
    "typescript": "5.8.3",
    "typescript-eslint": "8.62.0"
  }
}
